import { render, staticRenderFns } from "./BaseMetas.vue?vue&type=template&id=5b4cf8d4&scoped=true"
import script from "./BaseMetas.vue?vue&type=script&lang=js"
export * from "./BaseMetas.vue?vue&type=script&lang=js"
import style0 from "./BaseMetas.vue?vue&type=style&index=0&id=5b4cf8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4cf8d4",
  null
  
)

export default component.exports